import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { ErrorModalLabel_EN } from '../../models/labels/errorModalLabel_EN';
import { AuthorisationService } from '../../services/authorisation/authorisation.service';
import { BorrowerRenderingService } from '../../services/borrower/borrower-rendering.service';
import { BorrowerDTO } from '../../models/borrower/borrower-dto';
import { IncomeDTO } from '../../models/borrower/income-dto';
import { LoanStep1 } from '../../models/borrower/loan-step1';
import { Router } from '@angular/router';
import { QuoteRenderingService } from '../../services/search/quote-rendering.service';
import { LoanStep2 } from '../../models/borrower/loan-step2';
import { Parameter } from '../../models/borrower/loanFormParameter';
import { NewQuote } from '../../models/search/new-quote';
import { QuotationEntityIdDto } from '../../models/search/quotation-entity-id-dto';
import { SearchQuote } from '../../models/search/search-quote';
import { LoginRenderingService } from '../../services/login/login-rendering.service';
import { DLPRestUtilityService } from 'src/app/services/rest/dlprest-utility.service';

@Component({
  selector: 'app-logout-modal',
  templateUrl: './logout-modal.component.html',
  styleUrls: ['./logout-modal.component.scss']
})
export class LogoutModalComponent implements OnInit {
  label: any;

  constructor(public dialogRef: MatDialogRef<LogoutModalComponent>,
    private authorisationService: AuthorisationService, private router: Router,
    private borrowerService: BorrowerRenderingService, private quoteService: QuoteRenderingService,
    private loginService: LoginRenderingService,
    private dlpRestService: DLPRestUtilityService,
   ) { }

  ngOnInit() {
    // this.setTheme();
    this.label = new ErrorModalLabel_EN();

  }

  // setTheme() {
  //   let currentUser: any;
  //   currentUser = JSON.parse(localStorage.getItem('currentUser'));

  //   var logBtn = document.getElementsByClassName('logBtn')[0] as HTMLElement;
  //   var noBtn = document.getElementsByClassName('noBtn')[0] as HTMLElement;

  //   if (currentUser.brandIds.length == 3 && (currentUser.brandIds[0] != currentUser.brandIds[1]) && (currentUser.brandIds[0] != currentUser.brandIds[2] && (currentUser.brandIds[1] != currentUser.brandIds[2]))) {
  //     logBtn.style.cssText = "background-color: #C3002F";
  //     noBtn.style.cssText = "background-color: #C3002F";
  //     return "NISSAN";
  //   }
  //   else if (currentUser.brandIds.length == 2) {
  //     if (currentUser.brandIds[0] == "NISSAN" || currentUser.brandIds[1] == "NISSAN") {
  //       logBtn.style.cssText = "background-color: #C3002F";
  //       noBtn.style.cssText = "background-color: #C3002F";
  //       return "NISSAN";
  //     }
  //   }
  //   else {
  //     if (currentUser.brandIds.length == 1) {
  //       if (currentUser.brandIds[0] == "DATSUN") {
  //         logBtn.style.cssText = "background-color: #273486";
  //         noBtn.style.cssText = "background-color: #273486";
  //         return "DATSUN";
  //       }
  //       else if (currentUser.brandIds[0] == "RENAULT") {
  //         logBtn.style.cssText = "background-color: #FFCE00";
  //         noBtn.style.cssText = "background-color: #FFCE00";
  //         return "RENAULT";
  //       }
  //       else if (currentUser.brandIds[0] == "NISSAN") {
  //         logBtn.style.cssText = "background-color: #C3002F";
  //         noBtn.style.cssText = "background-color: #C3002F";
  //         return "NISSAN";
  //       }
  //     }
  //   }
  // }


  logout() {
    this.authorisationService.logoutExpireToken();

    this.authorisationService.logout();


    this.borrowerService.primaryBorrower = new BorrowerDTO();
    this.borrowerService.incomeBorrower = new IncomeDTO();
    this.borrowerService.incomeCoBorrower = new IncomeDTO();
    this.borrowerService.loanStep1 = new LoanStep1();
    this.borrowerService.loanStep2 = new LoanStep2();
    this.borrowerService.parameter = new Parameter();
    this.borrowerService.coApplicantBorrower = new BorrowerDTO();

    this.quoteService.newQuote = new NewQuote();
    this.quoteService.quotation = new QuotationEntityIdDto();
    this.quoteService.searchQuote = new SearchQuote();
    this.quoteService.checkModifyButton = false;

    this.dialogRef.close();
    this.router.navigate(['/logout']);
  }

  
  onNoClick(): void {
    this.dialogRef.close();
  }


}
